<div class="container-fluid card p-3 mt-3" *ngIf="!isLoading && accessDenied">
  <h3 class="text-center mb-3">Not authorised</h3>
  <p class="text-center">
    This observation is about someone at or above your level, so you cannot view it.
  </p>
  <div class="text-center">
    <button mat-raised-button color="warn" routerLink="/home/education/education-observation-list">Back</button>
  </div>
</div>

<div class="container-fluid card p-3 mt-3" *ngIf="!isLoading && observation">
  <h2 class="mb-3 text-primary">Observation Details</h2>
  <table class="table table-bordered">
    <tbody>
    <tr>
      <th width="30%">Session Date</th>
      <td>{{ observation.sessionDate.toDate() | date:'dd MMM yyyy' }}</td>
    </tr>
    <tr>
      <th>Observer Name</th>
      <td>{{ observation.observerName }}</td>
    </tr>
    <tr>
      <th>Teacher Name</th>
      <td>{{ observation.teacherName }}</td>
    </tr>
    <tr>
      <th>Centre</th>
      <td>{{ observation.centreName }}</td>
    </tr>
    <tr>
      <th>Session Type</th>
      <td>{{ observation.sessionType }}</td>
    </tr>
    <tr>
      <th>Subject</th>
      <td>{{ observation.subject }}</td>
    </tr>
    <tr>
      <th>Topic</th>
      <td>
        <div class="text-content">
          {{
            expandedFields['topic']
              ? formatField(observation.topic)
              : getTruncatedText(formatField(observation.topic))
          }}

          <button
            *ngIf="shouldShowMoreButton(formatField(observation.topic))"
            class="btn btn-link btn-sm p-0 ms-2"
            (click)="toggleExpanded('topic')">
            {{ expandedFields['topic'] ? 'Show Less' : 'Show More' }}
          </button>
        </div>
      </td>
    </tr>

    <tr>
      <th>Teaching Aid Used</th>
      <td>
        <div class="text-content">
          {{
            expandedFields['teachingAid']
              ? formatField(observation.teachingAid)
              : getTruncatedText(formatField(observation.teachingAid))
          }}

          <button
            *ngIf="shouldShowMoreButton(formatField(observation.teachingAid))"
            class="btn btn-link btn-sm p-0 ms-2"
            (click)="toggleExpanded('teachingAid')">
            {{ expandedFields['teachingAid'] ? 'Show Less' : 'Show More' }}
          </button>
        </div>
      </td>
    </tr>

    <tr>
      <th>Observation Comments</th>
      <td>
        <div class="text-content">
          {{ expandedFields['observationComment'] ? observation.observationComment : getTruncatedText(observation.observationComment) }}
          <button
            *ngIf="shouldShowMoreButton(observation.observationComment)"
            class="btn btn-link btn-sm p-0 ms-2"
            (click)="toggleExpanded('observationComment')">
            {{ expandedFields['observationComment'] ? 'Show Less' : 'Show More' }}
          </button>
        </div>
      </td>
    </tr>
    <tr>
      <th>Suggestions</th>
      <td>
        <div class="text-content">
          {{ expandedFields['suggestions'] ? observation.suggestions : getTruncatedText(observation.suggestions) }}
          <button
            *ngIf="shouldShowMoreButton(observation.suggestions)"
            class="btn btn-link btn-sm p-0 ms-2"
            (click)="toggleExpanded('suggestions')">
            {{ expandedFields['suggestions'] ? 'Show Less' : 'Show More' }}
          </button>
        </div>
      </td>
    </tr>
    </tbody>
  </table>
  <div class="row justify-content-center d-flex mt-3">
    <div class="col-md-4">
      <button mat-raised-button color="warn" routerLink="/home/education/education-observation-list">
        Back to List
      </button>
    </div>
  </div>
</div>
<div class="spinner-container" *ngIf="isLoading">
  <mat-spinner diameter="60"></mat-spinner>
</div>
